import React from "react";

interface StarIconProps {
  size?: number;
  color?: string;
  filled?: boolean;
}

export default function StarIcon({ size = 16, color = "#666", filled = false }: StarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 1l2.163 4.279L15 5.969l-3.5 3.41L12.326 15 8 12.729 3.674 15 4.5 9.379 1 5.969l4.837-.69L8 1z"
        fill={filled ? color : "none"}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}